module.exports = __webpack_public_path__ + "static/media/img12.93dca917.jpg";